import {
  LabSelectionWidget,
  UnitSelectionWidget,
  RoleSelectionWidget,
} from "components/FormWidget";

const uiSchema = () => ({
  lab_id: {
    "ui:widget": LabSelectionWidget,
    "ui:options": {
      initFilter: {
        for_admin: 1,
      },
    },
  },
  unit_id: {
    "ui:widget": UnitSelectionWidget,
    "ui:options": {
      initFilter: {
        for_admin: 1,
      },
    },
  },
  role_id: {
    "ui:widget": RoleSelectionWidget,
  },
});

export default uiSchema;
